export const environment = {
  production: false,
  apiUrl: 'https://api-turnos-dev.municipiodurango.gob.mx/api',
  turnadorTramitesUrl: 'https://turnos-dev.municipiodurango.gob.mx/#/tramites',
};
